module.exports = __webpack_public_path__ + "static/media/19valkas_edited.eecb6af3.jpg";